export const formatFilteredDataUrl = (url, filters) => {
  for (const prop in filters) {
    if (filters[prop]?.length > 0 && filters[prop] !== "All") {
      url += `&${prop}=${filters[prop]}`;
    }
  }
  return url;
};
